import type { TypedNativeModules } from './types/NativeModulesTypes';

import { proxyBridges } from './internal/proxyBridges';

import { createContext, type PropsWithChildren, use } from 'react';

const ctx = createContext<Partial<TypedNativeModules>>(proxyBridges({ RNTareBridge: {} }));

export function useBridge<K extends keyof TypedNativeModules>(
    bridge: K,
): TypedNativeModules[K] | undefined {
    const implementations = use(ctx);
    return implementations[bridge];
}

export function BridgeProvider<K extends keyof TypedNativeModules>({
    implementations,
    children,
}: PropsWithChildren<{
    implementations: { [_Y in K]: TypedNativeModules[K] };
}>) {
    return <ctx.Provider value={implementations}>{children}</ctx.Provider>;
}
